import { localize } from '../helpers';

export const templates = (translations: Record<string, string>, module: string) => {
    const data = {
        findNdsPayer: {
            nameServices: localize('find-nds-payer-service-search-vat-data', translations) + ':',
            link: '<div>[portal-host]/services/isnaportalsync/public/search-payer-data,</div> <div>[portal-host]/services/isnaportalsync/public/check-certificate-number-and-series-for-compliance</div>',
            method: 'GET',
            params:
                '<div>taxpayerCode: <ИИН/БИН></div>' +
                '<div>number: <Номер свидетельства></div>' +
                '<div>series: <Серия свидетельства></div>',
            resultExample: `{
    "iinBin": "string",
    "nameRu": "string",
    "nameEn": "string", 
    "nameKz": "string",
    "ndsRegistrationDate": "string",
    "ndsDeregistrationDate": "string",
    "ndsDeregistrationReason": "string" 
}`,
        },
        ServiceUnreliableTaxpayers: {
            nameServices: 'Поиск неблагонадежных НП:',
            link: '[portal-host]/services/isnaportal/public/taxpayer-data/search',
            method: 'POST',
            params: `-`,
            titleBody: 'Тело запроса: JSON-объект вида:',
            requestBody: `{
    "taxPayerCode": "String",
    "language": "rus",
    "rnn": "String",
    "taxPayerOrgName": "String",
    "directorIin": " String",
    "firstName": "String",
    "lastName": "String",
    "middleName": " String"
}`,
            resultExample: `[
    {
        "iin": "675344340213",
        "rnn": "2114343466660",
        "activity": null,
        "name": "ПРИМЕР РЕЗУЛЬТАТОВ СЕРВИСОВИЧ",
        "region": null,
        "taxOrgCode": null,
        "fullName": " ПРИМЕР РЕЗУЛЬТАТОВ СЕРВИСОВИЧ ",
        "directorFullName": "ПРИМЕР РЕЗУЛЬТАТОВ",
        "directorIin": "6704242300213",
        "directorRnn": null,
        "taxpayerDataList": [
            {
                "unreliableTaxpayerDataCategory": "ABSENT_ADDRESS_AGENT_DATA_LIST",
                "taxOrgCode": "2108",
                "dataReportDate": null,
                "actType": "ABSENT_ADDRESS",
                "actNumber": "132249",
                "actCreateDate": "2019-11-15T06:26:00"
            }
        ]
    }
]`,
        },
        FindTaxpayerService: [
            {
                nameServices: localize('api-search-tp', translations),
                link: '[portal-host]/services/isnaportalsync/public/taxpayer-data',
                method: 'GET',
                paramsTitle: 'Физическое лицо:',
                params: '<div>taxpayerCode: <ИИН></div>' + '<div>taxpayerType: FL</div>',
                resultExample: `{
  "taxpayerPortalSearchResponses": [
    {
      "responseMessageUid": "string",
      "messageResult": "string",
      "errorMessage": "string",
      "code": "string",
      "taxpayerType": "string",
      "fullName": {
        "lastName": "string",
        "firstName": "string",
        "middleName": "string"
      },
      "registrationType": {
        "code": "string",
        "ru": "string",
        "kk": "string",
        "en": "string",
        "qq": "string"
      },
      "beginDate": "string",
      "endDate": "string",
      "endReasonCode": "string",
      "additionalInfo": "string",
      "taxOrg": "string"
    }
  ]
}`,
            },
            {
                paramsTitle: 'Индивидуальный предприниматель:',
                params:
                    '<div>taxpayerCode: <ИИН/БИН></div>' +
                    '<div>taxpayerType: IP</div>' +
                    '<div>name: <Наименование ИП></div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "IP",
            "fullName": "string or null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
            {
                paramsTitle: 'Юридическое лицо:',
                params:
                    '<div>taxpayerCode: <БИН></div>' +
                    '<div>taxpayerType: UL & UL_NR</div>' +
                    '<div>name: <Наименование организации></div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "UL",
            "fullName": "null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
            {
                paramsTitle: 'Лицо, занимающееся частной практикой:',
                params:
                    '<div>taxpayerCode: <ИИН></div>' +
                    '<div>firstName: <Имя></div>' +
                    '<div>lastName: <Фамилия></div>' +
                    '<div>taxpayerType: LZCHP</div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "LZCHP",
            "fullName": {
                "lastName": "string",
                "firstName": "string",
                "middleName": "string"
            },
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
        ],
        FindLiquidatedTaxpayer: {
            nameServices: 'Поиск НП на стадии ликвидации:',
            link: '[portal-host]/services/isnaportalsync/public/find-liquidated-taxpayer',
            method: 'GET',
            params: `{
    "taxpayerCode": "taxpayerCode",
    "name": "name",
    "fio": "fio",
    "date": "YYYY-MM-DD"
}`,
            resultExample: `[
    {
        "ru": "Товарищество с ограниченной ответственностью \"Атар\"",
        "kk": null,
        "en": null,
        "qq": null,
        "rnn": "30433333920",
        "iinBin": "923232323226",
        "firstName": null,
        "lastName": null,
        "middleName": null,
        "endDate": null,
        "beginDate": "2003-08-15",
        "type": "UL"
    }
]`,
        },
        FindRiskDegreeService: {
            nameServices: localize('api-risk-degree-category', translations),
            link: '[portal-host]/services/isnaportalsync/public/find-risk-degree',
            method: 'GET',
            params: localize('api-print-taxpayerCode', translations),
            resultExample: `{
    "taxpayerCode" : "iinBin",
    "name" : "NP name",
    "degree" : "degreeCode",
    "relevanceDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "beginDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "endDate" : "yyyy-mm-ddT00:00:00.000+00:00"
}`,
        },
        InfoAbsenceTaxDebt: {
            nameServices: 'Cведения об отсутствии (наличии) налоговой задолженности:',
            link: '[portal-host]/services/isnaportalsync/public/tax-debt-info',
            method: 'GET',
            params: `{
    "taxpayerCode": "ИИН/БИН налогоплательщика"
}`,
            resultExample: `{
    "iinBin": "94037870364",
    "totalArrear": 0,
    "totalTaxArrear": 0,
    "pensionContributionArrear": 0,
    "socialContributionArrear": 0,
    "socialHealthInsuranceArrear": 0,
    "taxOrgInfos": []
}`,
        },
        BankruptService: [
            {
                nameServices: 'Получения справочника типов сервисов',
                link: '[portal-host]/services/isnaportal/public/bankrupt-service/service-types',
                method: 'GET',
                resultExample: `[
    { 
        "id": null, 
        "code": "INITIATED_LAB", //тип сервиса
        "kk": null, 
        "ru": null, 
        "en": null, 
        "qq": null, 
        "rank": null, 
        "hasChild": null 
    }
]`,
            },
            {
                nameServices:
                    'Получение сведений по возбужденным процедурам банкротства и реабилитации юридических лиц',
                link: '[portal-host]/services/isnaportal/public/bankrupt-service/event-data',
                method: 'POST',
                titleBody: 'Тело запроса: JSON-объект вида:',
                requestBody: `{
    "serviceType": "string"
}`,
                resultExample: `{
  "bankruptMeetingList": [
    {
      "address": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "announcementDate": "string",
      "courtDate": "2025-07-17T13:50:37.110Z",
      "courtName": "string",
      "debtorData": {
        "address": "string",
        "iinBin": "string"
      },
      "tempManagerName": "string"
    }
  ],
  "bankruptRtkList": [
    {
      "debtorData": {
        "accepted": 0,
        "debtDate": "string",
        "documentList": [
          {
            "date": "2025-07-17T13:50:37.110Z",
            "name": "string"
          }
        ],
        "iinBin": "string",
        "nonAccepted": 0,
        "sum": 0
      },
      "fifthRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "firstRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "fourthRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "secondRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "seventhRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "sixthRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "thirdRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      }
    }
  ],
  "bankruptStartedList": [
    {
      "adminName": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "debtorData": {
        "activity": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "contacts": "string",
        "courtDecision": "2025-07-17T13:50:37.110Z",
        "directors": "string",
        "entryForceDate": "2025-07-17T13:50:37.110Z",
        "founders": "string",
        "iinBin": "string",
        "region": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "terminationCourtDecision": "2025-07-17T13:50:37.110Z",
        "terminationEntryForceDate": "2025-07-17T13:50:37.110Z"
      },
      "rehabilitationManagerName": "string"
    }
  ],
  "declaringBankruptList": [
    {
      "address": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "announcementDate": "string",
      "courtDate": "2025-07-17T13:50:37.110Z",
      "courtName": "string",
      "debtorData": {
        "address": "string",
        "iinBin": "string"
      },
      "tempManagerName": "string"
    }
  ],
  "grainRtkList": [
    {
      "debtorData": {
        "accepted": 0,
        "debtDate": "string",
        "documentList": [
          {
            "date": "2025-07-17T13:50:37.110Z",
            "name": "string"
          }
        ],
        "iinBin": "string",
        "nonAccepted": 0,
        "sum": 0
      },
      "fifthRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "firstRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "fourthRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "secondRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "seventhRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "sixthRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      },
      "thirdRank": {
        "alimonyRequirements": 0,
        "amountOfIncreases": 0,
        "budgetMandatoryPayments": 0,
        "citizenDemands": 0,
        "clearingClaims": 0,
        "copyrightAgreementRequirements": 0,
        "courtDecisionClaims": 0,
        "creditorCivilObligations": 0,
        "creditorLoanClaims": 0,
        "creditorObligationClaims": 0,
        "debtOnCustomDuties": 0,
        "debtOnTaxes": 0,
        "deductionArrears": 0,
        "employeeContractRemuneration": 0,
        "excludedRequirements": 0,
        "grainHoldersClaimsNoPledge": 0,
        "grainHoldersClaimsPledge": 0,
        "grainPledgePropertyClaims": 0,
        "mandatoryArrears": 0,
        "otherCreditorClaims": 0,
        "paymentOfRemuneration": 0,
        "paymentRequirements": 0,
        "pledgePropertyTransferClaims": 0,
        "rehabOrLiquidGrainReceiving": 0,
        "securedCreditorClaims": 0,
        "socialArrears": 0,
        "submissionDeadlineClaims": 0,
        "wagesAndCompensationPayments": 0
      }
    }
  ],
  "initBankruptList": [
    {
      "address": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "announcementDate": "string",
      "courtDate": "2025-07-17T13:50:37.110Z",
      "courtName": "string",
      "debtorData": {
        "address": "string",
        "iinBin": "string"
      },
      "tempManagerName": "string"
    }
  ],
  "initRehabList": [
    {
      "address": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "announcementDate": "string",
      "courtDate": "2025-07-17T13:50:37.110Z",
      "courtName": "string",
      "debtorData": {
        "address": "string",
        "iinBin": "string"
      },
      "tempManagerName": "string"
    }
  ],
  "liquidationProcedureList": [
    {
      "adminName": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "debtorData": {
        "activity": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "contacts": "string",
        "courtDecision": "2025-07-17T13:50:37.110Z",
        "directors": "string",
        "entryForceDate": "2025-07-17T13:50:37.110Z",
        "founders": "string",
        "iinBin": "string",
        "region": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "terminationCourtDecision": "2025-07-17T13:50:37.110Z",
        "terminationEntryForceDate": "2025-07-17T13:50:37.110Z"
      },
      "rehabilitationManagerName": "string"
    }
  ],
  "rehabMeetingList": [
    {
      "address": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "announcementDate": "string",
      "courtDate": "2025-07-17T13:50:37.110Z",
      "courtName": "string",
      "debtorData": {
        "address": "string",
        "iinBin": "string"
      },
      "tempManagerName": "string"
    }
  ],
  "rehabilitationStartedList": [
    {
      "adminName": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "debtorData": {
        "activity": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "contacts": "string",
        "courtDecision": "2025-07-17T13:50:37.111Z",
        "directors": "string",
        "entryForceDate": "2025-07-17T13:50:37.111Z",
        "founders": "string",
        "iinBin": "string",
        "region": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "terminationCourtDecision": "2025-07-17T13:50:37.111Z",
        "terminationEntryForceDate": "2025-07-17T13:50:37.111Z"
      },
      "rehabilitationManagerName": "string"
    }
  ],
  "rehabilitationTerminatedList": [
    {
      "adminName": "string",
      "adminOrManagerContacts": {
        "address": "string",
        "email": "string",
        "phone": "string"
      },
      "debtorData": {
        "activity": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "contacts": "string",
        "courtDecision": "2025-07-17T13:50:37.111Z",
        "directors": "string",
        "entryForceDate": "2025-07-17T13:50:37.111Z",
        "founders": "string",
        "iinBin": "string",
        "region": {
          "code": "string",
          "kk": "string",
          "ru": "string"
        },
        "terminationCourtDecision": "2025-07-17T13:50:37.111Z",
        "terminationEntryForceDate": "2025-07-17T13:50:37.111Z"
      },
      "rehabilitationManagerName": "string"
    }
  ]
}`,
            },
        ],
    };
    const result = data[module];
    return Array.isArray(result) ? { services: result } : result;
};
